import { NotificationConfiguration } from '../notification.templates';

export const RACI_DAY_BEFORE_REMINDER: NotificationConfiguration = {
  inapp: `A report is due tomorrow.`,
  email: {
    ctaKey: 'check_in_report',
  },
};
